
import React from 'react';
import { DailyNutrients } from '@/types/meal-plan';
import { MacroDonutWithLegend } from '@/components/shared/MacroDonutWithLegend';

interface NutrientChartsProps {
  nutrients: DailyNutrients;
  targets?: {
    calories?: number;
    protein?: number;
    carbs?: number;
    fat?: number;
    vitaminA?: number;
    vitaminC?: number;
    calcium?: number;
    iron?: number;
  };
}

const NutrientCharts: React.FC<NutrientChartsProps> = ({ 
  nutrients, 
  targets
}) => {
  
  
  // Use the carbs/protein/fat/fiber values (could be from totalCarbs or carbs field)
  const carbsGrams = nutrients.totalCarbs || nutrients.carbs || 0;
  const proteinGrams = nutrients.totalProtein || nutrients.protein || 0;
  const fatGrams = nutrients.totalFat || nutrients.fat || 0;
  const fiberGrams = nutrients.totalFiber || 0;

  return (
    <div className="space-y-6">
      <MacroDonutWithLegend
        carbs={carbsGrams}
        protein={proteinGrams}
        fat={fatGrams}
        fiber={fiberGrams}
        title="Macronutrient distribution"
        fiberLabel="Fiber"
      />
    </div>
  );
};

export default NutrientCharts;
